export const handleVisualizationStateStart = (state, payload) => {
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: true,
            error: false,
            reason: '',


        },


    };
};

export const handleVisualizationStateSuccess = (state, payload) => {
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: false,
            error: false,
            reason: '',
            data: payload.data.data,
        },
        isVisualizationDataFectched: true

    };
};

export const handleVisualizationStateFail = (state, payload) => {
    return {
        ...state,
        [payload.apiName]: {
            ...state[payload.apiName],
            isProcessing: false,
            error: true,
            reason: '',
            data: null,
        },
        isProcessing: false,
        error: false, reason: '',
        isVisualizationDataFectched: false

    };
};
